import { useState } from 'react';
import { MapPin, MapPinOff } from 'lucide-react';

export const LocationBody = ({
	row,
	openWorkLocationRestrictionDialog
}) => {
	return (
		<>
		<div className='flex w-full h-full justify-center content-center items-center'>
			{row.openWorkArea ? (
				<div
					title='El colaborador registra asistencia en cualquier ubicación'
					onClick={() => {
						openWorkLocationRestrictionDialog(row);
					}}
					className='flex w-3 h-3  rounded-full justify-center content-center items-center  cursor-pointer ml-1'>
					<MapPinOff className='text-xl' />
				</div>
			) : (
				<div
					title='El colaborador registra asistencia en sus centros y lugares de trabajo'
					onClick={() => {
						openWorkLocationRestrictionDialog(row)
					}}
					className='flex w-3 h-3  rounded-full justify-center content-center items-center  cursor-pointer ml-1'>
						
					<MapPin className='text-xl' />
				</div>
			)}
		</div>
		</>
	);
};
